import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  deprecated: {
    id: 'course-authoring.advanced-settings.button.deprecated',
    defaultMessage: 'Deprecated',
  },
  helpButtonText: {
    id: 'course-authoring.advanced-settings.button.help',
    defaultMessage: 'Show help text',
  },
});

export default messages;
